import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteData, getData, patchData } from '../Services/api'
import Pagination from '../Services/Pagination'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'

const CouponList = () => {
  const [coupons, setCoupons] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');

  const fetchCoupons = async (pageNumber = 1, searchQuery = '') => {
    try {
      const res = await getData(`/coupons/all?page=${pageNumber}&search=${searchQuery}`);
      if (res.status) {
        setCoupons(res.data || [])
        setPage(res.pagination.currentPage);
        setPages(res.pagination.totalPages);
        setTotal(res.pagination.totalRecords);
      }
    } catch (error) {
      console.log("error fetch coupons", error)
    }
  }

  useEffect(() => {
    fetchCoupons(page, search);
  }, [page, search]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber !== page) {
      fetchCoupons(pageNumber);
    }
  };

  const handleStatusChange = async (id) => {
    try {
      const res = await patchData(`/coupons/${id}/toggle`);
      if (res.status) {
        toast.success(res.message);
        fetchCoupons();
      }
    } catch (error) {
      console.log("error coupons status change", error)
    }
  }

  const handleDelete = (userId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await deleteData(`/coupons/delete/${userId}`,);
          if (res.status) {
            toast.success(res.message);
            fetchCoupons();
          }
        } catch (error) {
          console.log("error delete coupons", error)
        }
      }
    });
  }

  return (
    <>
      <div className="pc-container">
        <div className="pc-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/coupons/coupon-list">Coupons</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Coupons List
                    </li>
                  </ul>
                </div>
                <div className="col-md-12">
                  <div className="page-header-title">
                    <h2 className="mb-0">Coupons List</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card table-card">
                <div className="card-body">
                  <div className="d-sm-flex align-items-center p-4">
                    <ul className="list-inline me-auto my-1">
                      <li className="list-inline-item">
                        <div className="form-search">
                          <i className="fas fa-search" />
                          <input
                            type="search"
                            className="form-control"
                            placeholder="Search coupon by code"
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                              setPage(1);
                            }}
                          />
                        </div>
                      </li>
                    </ul>

                    <div className="text-end pb-sm-2">
                      <Link
                        to="/coupons/add-coupons"
                        className="btn btn-primary d-inline-flex align-item-center"
                      >
                        <i className="fas fa-plus f-18 me-2" /> Add Coupon
                      </Link>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-hover" id="pc-dt-simple">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Coupon Code</th>
                          <th>Discount Type</th>
                          <th>Discount Value</th>
                          <th>Expiry Date</th>
                          <th>Status</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          coupons?.length > 0 ? (
                            coupons?.map((user, index) => {
                              return (
                                <tr key={user._id}>
                                  <td>{index + 1 + (page - 1) * 10}.</td>
                                  <td>
                                    {user.code}
                                  </td>
                                  <td>{user.discountType}</td>
                                  <td>{user.discountValue}</td>
                                  <td>{user?.expiryDate?.split('T')[0]} </td>
                                  <td>
                                    <div className="form-check form-switch p-0">
                                      <input
                                        className="form-check-input h4 position-relative m-0"
                                        type="checkbox"
                                        role="switch"
                                        checked={user.isActive}
                                        onChange={() => handleStatusChange(user._id)}
                                      />
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <ul className="list-inline me-auto mb-0">
                                      <li
                                        className="list-inline-item align-bottom"
                                        data-bs-toggle="tooltip"
                                        title="View"
                                      >
                                        <Link
                                          to={`/coupons/view-coupon/${user.code}`}
                                          className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                        >
                                          <i className="fas fa-eye f-18" />
                                        </Link>
                                      </li>
                                      <li
                                        className="list-inline-item align-bottom"
                                        data-bs-toggle="tooltip"
                                        title="Edit"
                                      >
                                        <Link
                                          to={`/coupons/update-coupon/${user._id}`}
                                          state={{ code: user.code }}
                                          className="avtar avtar-xs btn-link-success btn-pc-default"
                                        >
                                          <i className="fas fa-edit f-18" />
                                        </Link>
                                      </li>
                                      <li
                                        className="list-inline-item align-bottom"
                                        data-bs-toggle="tooltip"
                                        title="Delete"
                                      >
                                        <a
                                          onClick={() => handleDelete(user._id)}
                                          className="avtar avtar-xs btn-link-danger btn-pc-default"
                                        >
                                          <i className="fas fa-trash f-18" />
                                        </a>
                                      </li>
                                    </ul>
                                  </td>
                                </tr>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={6} className='text-center'>No Coupons Found</td>
                            </tr>
                          )
                        }

                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                    <div className="text-muted">
                      Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                    </div>
                    <Pagination
                      page={page}
                      pages={pages}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CouponList